import { containerFrom, containerUpTo, containerNotSupported } from '../../styles/container';
import { makeStyles } from '../../styles/themes/themewrapper';
import { FLIGHT_OVERVIEW_SIZE, FLIGHT_OVERVIEW_NAME } from '../FlightTransfer/constants';

export const useCustomStyles = makeStyles<void, 'hasStopOver'>()((theme, _, classes) => {
	return {
		flightContainer: {
			display: 'flex',
			flexDirection: 'column',
			gap: theme.spacing.small,
		},

		flight: {
			display: 'flex',
			gap: theme.spacing.xxsmall,

			[containerFrom(FLIGHT_OVERVIEW_SIZE, FLIGHT_OVERVIEW_NAME)]: {
				gap: theme.spacing.medium,
			},
		},

		flightDetails: {
			flex: 1,
			display: 'flex',
			flexDirection: 'column',
			gap: theme.spacing.micro,
		},

		flightRow: {
			display: 'flex',
			gap: theme.spacing.xxsmall,
			flexDirection: 'column',

			[containerFrom(FLIGHT_OVERVIEW_SIZE, FLIGHT_OVERVIEW_NAME)]: {
				gap: theme.spacing.small,
				alignItems: 'center',
				flexDirection: 'row',
			},
		},

		flightNames: {
			[containerFrom(FLIGHT_OVERVIEW_SIZE, FLIGHT_OVERVIEW_NAME)]: {
				alignItems: 'center',

				'> div': {
					flex: 1,
					display: 'flex',
					justifyContent: 'center',

					'&:first-of-type': {
						justifyContent: 'flex-start',
					},

					'&:last-of-type': {
						justifyContent: 'flex-end',
					},
				},
			},
		},

		line: {
			flex: 1,
		},

		duration: {
			display: 'flex',
			gap: theme.spacing.xxsmall,
			flexDirection: 'column',

			[containerFrom(FLIGHT_OVERVIEW_SIZE, FLIGHT_OVERVIEW_NAME)]: {
				alignItems: 'center',
				flexDirection: 'row',
			},
		},

		timestamp: {
			font: theme.flightSelection.timestamp.font,
			color: theme.flightSelection.timestamp.color,
		},

		flightType: {
			color: theme.flightSelection.stops.color.direct,
			font: theme.flightSelection.stops.font,
			textTransform: 'uppercase',

			[`&.${classes.hasStopOver}`]: {
				color: theme.flightSelection.stops.color.transfer,
			},
		},

		travelTime: {
			font: theme.flightSelection.travelTime.font,
			color: theme.flightSelection.travelTime.color,
			/** Mostly for mobile */
			display: 'flex',
			alignItems: 'center',
			flexDirection: 'row',
			columnGap: theme.spacing.small,
			rowGap: theme.spacing.tiny,
			flexWrap: 'wrap',

			[containerFrom(FLIGHT_OVERVIEW_SIZE, FLIGHT_OVERVIEW_NAME)]: {
				flexDirection: 'column',
			},
		},

		airport: {
			font: theme.flightSelection.airport.font,
			color: theme.flightSelection.airport.color,
		},

		airline: {
			display: 'flex',
			alignItems: 'center',
			font: theme.flightSelection.airliner.font,
			color: theme.flightSelection.airline.color,
			gap: theme.spacing.tiny,

			[containerFrom(FLIGHT_OVERVIEW_SIZE, FLIGHT_OVERVIEW_NAME)]: {
				flex: 'none',
				textAlign: 'center',
			},
		},

		airlineText: {
			whiteSpace: 'nowrap',
		},

		timeStampWithAirport: {
			display: 'flex',
			alignItems: 'baseline',
			gap: theme.spacing.tiny,

			[containerFrom(FLIGHT_OVERVIEW_SIZE, FLIGHT_OVERVIEW_NAME)]: {
				textAlign: 'right',
				alignItems: 'baseline',
			},
		},

		stopOver: {
			display: 'flex',
			alignItems: 'center',
			gap: theme.spacing.xxsmall,
		},

		stopOverButton: {
			border: 0,
			background: 0,
			margin: 0,
			padding: 0,
			lineHeight: 0,
			color: theme.flightSelection.info.color,

			'&:hover': {
				cursor: 'pointer',
			},
		},

		isMobileOnly: {
			[containerFrom(FLIGHT_OVERVIEW_SIZE, FLIGHT_OVERVIEW_NAME)]: {
				display: 'none',
			},
		},

		isDesktopOnly: {
			[containerUpTo(FLIGHT_OVERVIEW_SIZE, FLIGHT_OVERVIEW_NAME)]: {
				display: 'none',
			},

			[containerNotSupported]: {
				display: 'none',
			},
		},

		transferBlock: {
			background: theme.palette.neutral[5],
			borderRadius: theme.borderRadius.rounded,
			padding: theme.spacing.small,
			marginTop: theme.spacing.small,
		},

		hasStopOver: {},
	};
});
